var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a3 3 0 013-3h5a3 3 0 013 3v4a3 3 0 01-3 3H5a3 3 0 01-3-3v-4z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C1.21 6.84 0 9.95 0 13.33c0 4.42 3.58 8 8 8s8-3.58 8-8C16 7.94 13.41 3.13 9.5 0zM7.71 18.33c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z",
    fill: "#F97316"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12a3 3 0 013-3h5a3 3 0 013 3v4a3 3 0 01-3 3H5a3 3 0 01-3-3v-4z",
    stroke: "#F97316"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C1.21 6.84 0 9.95 0 13.33c0 4.42 3.58 8 8 8s8-3.58 8-8C16 7.94 13.41 3.13 9.5 0zM7.71 18.33c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z",
    stroke: "#F97316"
  })));
}
export default SvgFire;